import AdUnit from '../../AdUnit';
import { useCardStyleAdEligibility } from '../../../../hooks/useCardStyleAdEligibility';

function QuizInterstitialAdUnit({buzz}) {
  const {
    isInterstitialAdEligible,
    isInlineAndInterstitialAdEligible
  } = useCardStyleAdEligibility(buzz);

  return (
    (
      isInterstitialAdEligible ||
      isInlineAndInterstitialAdEligible
    ) &&
    <AdUnit type="game-interstitial" />
  );
}
export default QuizInterstitialAdUnit;
